<template>
  <div class="flex items-center justify-center min-h-screen">
    <div class="text-center">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto"></div>
      <p class="mt-4 text-gray-600">Logging out...</p>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useStore } from 'vuex'

const store = useStore()

onMounted(async () => {
  try {
    // Use the existing logout action that handles everything including redirect
    await store.dispatch('logout')
  } catch (error) {
    console.error('Logout failed:', error)
    // The logout action should still handle the redirect even if there's an error
  }
})
</script>
